import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { WHATSAPP_URL } from "@/lib/config";

const NAV = [
    { label: "Cómo funciona", href: "#como-funciona" },
    { label: "Por qué Puertalia", href: "#por-que" },
    { label: "Opiniones", href: "#opiniones" },
];

export const Header = () => (
    <motion.header
        initial={{ y: -64, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="sticky top-0 z-40 border-b border-white/10 bg-brand-ink/95 backdrop-blur-md"
        data-testid="header"
    >
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
            <a href="/" aria-label="Puertalia Portal, inicio" data-testid="header-logo-link">
                <Logo light />
            </a>
            <nav className="hidden items-center gap-7 md:flex" aria-label="Navegación principal">
                {NAV.map((item) => (
                    <a
                        key={item.href}
                        href={item.href}
                        className="font-sans text-sm font-medium text-white/70 transition-colors duration-200 hover:text-white"
                    >
                        {item.label}
                    </a>
                ))}
            </nav>
            <motion.a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="header-whatsapp-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.96 }}
                className="flex items-center gap-2 rounded-full bg-brand-wa px-4 py-2 font-sans text-sm font-bold text-white shadow-lg shadow-brand-wa/25 transition-colors duration-200 hover:bg-brand-wadark"
            >
                <MessageCircle className="h-4 w-4" strokeWidth={2.4} />
                <span className="hidden sm:inline">WhatsApp</span>
                <span className="sm:hidden">Chat</span>
            </motion.a>
        </div>
    </motion.header>
);
